import * as React from 'react'
// context
import { ReviewsListBLContext } from 'containers/Review/ReviewList/layers/BL'
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// types
import { IReview } from 'types/graphql'
// utils
import filter from 'lodash/fp/filter'
import orderBy from 'lodash/fp/orderBy'
import pipe from 'lodash/fp/pipe'
import { getClosestReview } from 'utils/reviews'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  review: IReview & any
}

export const CompleteReviewBLContext = React.createContext<IContext>({} as any)

const CompleteReviewBL: React.FC<Props> = ({ children }) => {
  const { reviews } = React.useContext(ReviewsListBLContext)
  const { review, isReview } = React.useContext(CreateReviewBLContext)

  const filteredReviews = pipe(
    filter((review: IReview & any) => review.status !== REVIEW_STATUSES.COMPLETE),
    orderBy((review: IReview & any) => review.dueDate.valueOf(), 'asc')
  )(reviews)

  const closestReview = getClosestReview(false, filteredReviews)

  const value = {
    review: isReview ? review : closestReview
  }

  return (
    <CompleteReviewBLContext.Provider value={value}>{closestReview ? children : null}</CompleteReviewBLContext.Provider>
  )
}

export default CompleteReviewBL
